import { RotateCcw } from "lucide-react";

import FilterBar from "../ui/FilterBar";
import FilterSelect from "../ui/FilterSelect";
import Button from "../ui/Button";
import { useAuthStore } from "../../store/authStore";

const PRICE_UNITS = ["K", "L", "Cr"];

const toUniqueFilterOptions = (items = []) => {
  return Array.from(
    new Set(
      items
        .map((item) => (typeof item === "string" ? item.trim() : item))
        .filter((item) => item && item !== "All"),
    ),
  )
    .sort((a, b) => String(a).localeCompare(String(b)))
    .map((value) => ({ label: value, value }));
};

function PriceField({ placeholder, value, unit, onValueChange, onUnitChange }) {
  return (
    <div className="properties-price-field">
      <input
        type="number"
        className="filter-select properties-price-input"
        placeholder={placeholder}
        value={value}
        min="0"
        onChange={(e) => onValueChange(e.target.value)}
      />
      <select
        className="filter-select properties-price-unit"
        value={unit}
        onChange={(e) => onUnitChange(e.target.value)}
        aria-label={`${placeholder} unit`}
      >
        {PRICE_UNITS.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default function PropertiesFilters({
  filterAgent,
  setFilterAgent,
  filterArea,
  setFilterArea,
  filterCountry,
  setFilterCountry,
  minPrice,
  setMinPrice,
  minPriceUnit,
  setMinPriceUnit,
  maxPrice,
  setMaxPrice,
  maxPriceUnit,
  setMaxPriceUnit,
  agents = [],
  properties = [],
  onReset,
}) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";
  const areaOptions = toUniqueFilterOptions(properties.map((p) => p.area));
  const countryOptions = toUniqueFilterOptions(
    properties.map((p) => p.country),
  );

  const hasActiveFilters =
    (isAdmin && filterAgent !== "All") ||
    filterArea !== "All" ||
    filterCountry !== "All" ||
    minPrice !== "" ||
    maxPrice !== "";

  return (
    <FilterBar className="properties-filters">
      <div className="properties-filters-fields">
        {isAdmin && (
          <FilterSelect
            label="Agent"
            value={filterAgent}
            onChange={(e) => setFilterAgent(e.target.value)}
            options={[{ label: "All Agents", value: "All" }, ...agents]}
          />
        )}

        <FilterSelect
          label="Area"
          value={filterArea}
          onChange={(e) => setFilterArea(e.target.value)}
          options={[{ label: "All Areas", value: "All" }, ...areaOptions]}
        />

        <FilterSelect
          label="Country"
          value={filterCountry}
          onChange={(e) => setFilterCountry(e.target.value)}
          options={[{ label: "All Countries", value: "All" }, ...countryOptions]}
        />

        <div className="filter-item properties-price-range">
          <span className="filter-label">Price Range</span>
          <div className="properties-price-range-row">
            <PriceField
              placeholder="Min"
              value={minPrice}
              unit={minPriceUnit}
              onValueChange={setMinPrice}
              onUnitChange={setMinPriceUnit}
            />
            <span className="properties-price-sep">–</span>
            <PriceField
              placeholder="Max"
              value={maxPrice}
              unit={maxPriceUnit}
              onValueChange={setMaxPrice}
              onUnitChange={setMaxPriceUnit}
            />
          </div>
        </div>
      </div>

      <Button
        type="button"
        variant="outline"
        className="properties-filter-reset"
        onClick={onReset}
        disabled={!hasActiveFilters}
      >
        <RotateCcw size={15} />
        Reset
      </Button>
    </FilterBar>
  );
}
